import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { GradientButton } from '../gradients/GradientButton';
import { GradientTypography } from '../gradients/GradientTypography';
import { useTheme } from '@mui/material/styles';
import { DownloadGameDialog } from '../game-download/DownloadGameDialog';
import { useState } from 'react';
import { DOWNLOAD_DIALOG_PROPS } from '../../util/game/downloadDialogue';
import { Competition } from 'functions/src/types/firestore/Game/Competition';
import { usePrizeFormat } from 'src/hooks/usePrizeFormat';

type JoinNowProps = Pick<Competition, 'blurb' | 'prize'>;

export function JoinNow({ blurb, prize }: JoinNowProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const theme = useTheme();
  const prizeFormatted = usePrizeFormat(prize);
  return (
    <Box sx={{ width: 'min(586px, 100%)' }}>
      {dialogOpen && (
        <DownloadGameDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          {...DOWNLOAD_DIALOG_PROPS['Undead Blocks']}
        />
      )}
      <GradientTypography
        gradientColor="primary.vertical"
        variant="h5"
        sx={{
          mb: 1,
          ml: 3,
        }}
      >
        JOIN NOW
      </GradientTypography>
      <Stack
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        sx={{
          position: 'relative',
          borderRadius: '10px',
          border: 'solid 2px transparent',
          backgroundImage: `linear-gradient(${theme.palette.background.elevationSolid[10]}, 
            ${theme.palette.background.elevationSolid[10]}), 
            ${theme.palette.primary.vertical}`,
          backgroundOrigin: 'border-box',
          backgroundClip: 'content-box, border-box',
          boxShadow: theme.shadows[4],
          '&:hover': {
            boxShadow: theme.shadows[7],
          },
        }}
      >
        <Stack
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          gap="8px"
          sx={{ width: '50%', py: 8, ml: 8, mr: 4 }}
        >
          <GradientTypography
            gradientColor="warning.horizontal"
            variant="h6"
            sx={{ textAlign: 'center' }}
          >
            {blurb?.title?.toUpperCase()}
          </GradientTypography>
          <Typography variant="h6" sx={{ textAlign: 'center' }}>
            {blurb?.description}
          </Typography>
          <GradientButton
            size="large"
            variant="outlined"
            sx={{
              whiteSpace: 'nowrap',
              mt: 1,
            }}
            onClick={() => setDialogOpen(true)}
          >
            REGISTER IN-GAME
          </GradientButton>
        </Stack>
        <Divider
          variant="fullWidth"
          orientation="vertical"
          sx={{
            height: '120px',
            backgroundImage:
              'radial-gradient(circle, rgba(0, 100, 233, 0) 0%, #4DC8FF 0%, rgba(0, 100, 233, 0) 100%)',
          }}
        />
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ width: '50%', ml: 4, mr: 8 }}
        >
          <GradientTypography gradientColor="secondary.vertical" variant="h2">
            {prizeFormatted}
          </GradientTypography>
          <Typography variant="h4">PRIZE POOL</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
